import { render } from "./CancelAdmin.vue?vue&type=template&id=315db07a&scoped=true"
import script from "./CancelAdmin.vue?vue&type=script&lang=js"
export * from "./CancelAdmin.vue?vue&type=script&lang=js"

import "./CancelAdmin.vue?vue&type=style&index=0&id=315db07a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315db07a"]])

export default __exports__